// /src/api/ImovelUpdateEngine.js
// VERSÃO 44.1 SUPREMA - TIM UNITY UPGRADE ENGINE (DATA POWER & PRECISION FINANCE)

import apiClient from './apiClient';
import { toast } from 'react-toastify';

export const ImovelUpdateEngine = {

    /**
     * 🔄 TRADUTOR DE UPGRADE: PREPARAÇÃO DO MALOTE DE EDIÇÃO
     */
    prepararPayloadEdicao: (formData, removedImages = []) => {
        const data = new FormData();

        // 💰 MOTOR DE DECIMAIS: Purificação de centavos (Padrão Major-V44)
        const parseCurrency = (val) => {
            if (!val && val !== 0) return 0;
            if (typeof val === 'number') return val;
            const cleanString = String(val)
                .replace(/[R$\s]/g, '')
                .replace(/\./g, '')
                .replace(',', '.');
            return parseFloat(cleanString) || 0;
        };

        // --- 1. DADOS PRIMITIVOS (DNA DO PLANO) ---
        const primitives = {
            titulo: formData.titulo || '',
            codigoImovel: String(formData.codigoImovel || '').trim(),
            quantidadegb: Number(formData.quantidadegb || 0), 
            nomeImobiliaria: formData.nomeImobiliaria || 'Unity - Contabilizoom',
            creci: String(formData.creci || '').trim(),
            tipoNegocio: formData.tipoNegocio || 'Linhas novas',
            tipoPrincipal: formData.tipoPrincipal || 'CNPJ',
            subtipo: formData.subtipo || '',
            descricao: formData.descricao || '',
            entidadeId: formData.entidadeId || '',
            usuarioId: formData.usuarioId || '',
            videoUrl: formData.videoUrl || '',
            isDestaque: formData.isDestaque === true ? 'true' : 'false',
            seloDestaque: formData.seloDestaque || '',
            
            // 🛰️ FLAGS DE CIRCUITO
            isVIP: formData.isVIP || 'Não',
            isPortabilidade: formData.isPortabilidade || 'Não',
            isClienteTIM_CPF: formData.isClienteTIM_CPF || 'Não',
            
            // 🛡️ ARSENAL DE BENEFÍCIOS
            beneficio1: formData.beneficio1 || '',
            beneficio2: formData.beneficio2 || '',
            beneficio3: formData.beneficio3 || '',
            beneficio4: formData.beneficio4 || '',

            nivelCobertura: formData.nivelCobertura || 'Brasil'
        };

        Object.entries(primitives).forEach(([key, val]) => data.append(key, val));

        // --- 2. ESTRUTURAS COMPLEXAS (JSON) ---
        
        data.append('estadosCobertura', JSON.stringify(formData.estadosCobertura || []));
        data.append('locaisCirurgicos', JSON.stringify(formData.locaisCirurgicos || []));

        data.append('localizacao', JSON.stringify({
            cep: formData.cep || '', 
            rua: formData.rua || '', 
            numero: formData.numero || '',
            bairro: formData.bairro || '', 
            cidade: formData.cidade || '', 
            estado: formData.estado || ''
        }));

        data.append('caracteristicas', JSON.stringify({
            quartos: String(formData.quartos || 'Não'),      // Voz
            suites: String(formData.suites || 'Não'),        // Social
            banheiros: String(formData.banheiros || 'Não'),  // Redes
            vagasGaragem: String(formData.vagasGaragem || ''), // Apps
            areaUtil: String(formData.areaUtil || ''),       // Extras
            areaTotal: String(formData.areaTotal || 'Não')   // Roaming
        }));

        data.append('valores', JSON.stringify({
            venda: parseCurrency(formData.valorVenda),      // ✅ Centavos validados na edição
            aluguel: parseCurrency(formData.valorAluguel),
            condominio: parseCurrency(formData.valorCondominio),
            iptu: String(formData.valorIptu || '')
        }));

        data.append('seo', JSON.stringify({
            metaTitle: formData.seoTitulo || '', 
            metaDescription: formData.seoDescricao || ''
        }));

        data.append('removedImages', JSON.stringify(removedImages));

        return data;
    },

    /**
     * 🔥 MOTOR DE ENVIOS EM BLOCO (PATCHING DE MÍDIA)
     */
    executarSincroniaMidia: async (imovelId, fieldName, allFiles) => {
        const newFiles = allFiles.filter(f => f instanceof File);
        if (newFiles.length === 0) return true;

        const BATCH_SIZE = 5;
        const totalBatches = Math.ceil(newFiles.length / BATCH_SIZE);

        for (let i = 0; i < totalBatches; i++) {
            const batch = newFiles.slice(i * BATCH_SIZE, (i + 1) * BATCH_SIZE);
            const data = new FormData();
            batch.forEach(file => data.append(fieldName, file));

            toast.info(`📦 Malote ${i + 1}/${totalBatches} de ${fieldName}...`, { 
                autoClose: 1000,
                style: { fontSize: '10px', fontWeight: '900', textTransform: 'uppercase' }
            });
            
            await apiClient.patch(`/api/imoveis/${imovelId}/upload-batch`, data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        }
        return true;
    },

    /**
     * 🚀 EXECUÇÃO DO UPGRADE NA PONTE
     */
    executarUpdate: async (imovelId, payload) => {
        try {
            const response = await apiClient.put(`/api/imoveis/${imovelId}`, payload, {
                headers: { 'Content-Type': 'multipart/form-data' },
                timeout: 60000 
            });
            return response.data;
        } catch (error) {
            console.error("🚩 [UPGRADE FAILED]:", error);
            throw error;
        }
    }
};